export enum CardEnum {
  RED = 'red',
  YELLOW = 'yellow',
  YELLOW_RED = 'yellow_red',
}

export enum SubstitutionTypeEnum {
  IN = 'in',
  OUT = 'out',
}

export enum NeutralIncidentTypeEnum {
  START = 'start',
  END = 'end',
  START_EXTRA_TIME = 'start_extra_time',
  END_EXTRA_TIME = 'end_extra_time',
  NOT_ENOUGH_PlAYERS = 'not_enough_players',
  START_PENALTY = 'start_penalty',
  END_PENALTY = 'end_penalty',
}
